export const AddCreditCardComponent = {
    require: {
        checkout: '^checkoutStep',
    },
    bindings: {
        save: '@?'
    },
    template: `
        <fieldset>
            <ng-form name="$ctrl.paymentForm">
                <div class="flex-row expand">
                    <div class="column column-sm-12">
                        <credit-card-number
                            form="$ctrl.paymentForm"
                            current-payment="$ctrl.paymentData"
                            class="field-control"
                        ></credit-card-number>
                    </div>
                </div>
                <div class="flex-row expand">
                    <div class="column column-md-4">
                        <card-expiration-date
                            form="$ctrl.paymentForm"
                            current-payment="$ctrl.paymentData"
                            class="field-control"
                        ></card-expiration-date>
                    </div>
                    <div class="column column-md-4">
                        <card-verification-value
                            form="$ctrl.paymentForm"
                            current-payment="$ctrl.paymentData"
                        ></card-verification-value>
                    </div>
                    <div class="column column-md-4">
                        <card-postal-code
                            form="$ctrl.paymentForm"
                            current-payment="$ctrl.paymentData"
                            class="field-control"
                        ></card-postal-code>
                    </div>
                </div>
                <div class="checkbox-container" ng-if="$ctrl.maySave()">
                    <input id="save-card" c-check type="checkbox" ng-model="$ctrl.paymentData.saveCard">
                    <label for="save-card">Remember this card</label>
                    <p>
                        By selecting "Remember this card" and clicking on "Save" you are authorizing Toast, Inc. to store your 
                        credit card information provided above (the "Card"), and to charge your Card for future purchases 
                        initiated by you. You may update your Card information or cancel this authorization any time via the 
                        "My Account" page of the Toast Online Ordering website. This authorization will remain in effect until 
                        updated or canceled.
                    </p>
                </div>
            </ng-form>
        </fieldset>
    `,
    controller: class {
        constructor(paymentService) {
            'ngInject';
            Object.assign(this, { paymentService });

            this.paymentData = this._setupPaymentData();
            if(this.paymentData.saveCard === null)
                this.paymentData.saveCard = true;
            this.paymentData.isPrimary = false;

            // TODO better handle edge case when user logs out after selecting saved payment on checkout page.
            this.paymentData.guid = null;
        }

        _setupPaymentData() {
            if(this.maySave()) {
                return this.paymentService.data.tempPayment;
            }

            return this.paymentService.data.selectedPayment;
        }

        maySave() {
            return this.save === 'optional';
        }
    }
};
